<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "Services",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('services.plural')) }},
    resourceRoute: {default: 'services'},
    modelVariable: {default: 'service'},
    denyCreate: { type: Boolean, default: true },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('services.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('services.plural')),
          href: "/services",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'id',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        name: { type: String, label: this.lodash.startCase(this.$t('services.name')) },
        phone_number: { type: String, label: this.lodash.startCase(this.$t('services.phone_number')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['service']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'name',
            label: this.lodash.startCase(this.$t('services.name')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<div style="width: 200px" class="text-truncate" :title="item.name">{{ item.name }}</div>'
            }
          },
          {
            key: 'fee',
            label: this.lodash.startCase(this.$t('services.fee')),
            thStyle: {minWidth: '100px'},
            sortable: false,
            component: {
              props: ['item'],
              template: '<span>{{ $numeral(item.fee).format("$ 0,0.[000]") }}</span>'
            }
          },
          {
            key: 'type',
            label: 'Kategori',
            thStyle: {minWidth: '100px'},
            sortable: false,
            formatter: (value) => value ? this.lodash.upperFirst(this.$t(`shrimps.types.${value}`)) : '-',
          },
          {
            key: 'is_active',
            label: this.lodash.startCase(this.$t('services.is_active')),
            thStyle: {minWidth: '100px'},
            sortable: false,
            formatter: (value) => this.lodash.startCase(value ? this.$t('services.active') : this.$t('services.inactive'))
          },
          {
            key: 'creator.name',
            label: this.lodash.startCase(this.$t('models.created_by')),
            thStyle: {minWidth: '100px'},
            sortable: false,
            formatter: (value) => value || '-'
          },
          { key: 'action', label: this.$t('Action'), class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/shrimps/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/shrimps', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          is_beta__eq: 1,
          with: 'creator',
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          ...this.modelPolicy(),
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    },
    modelPolicy() {
      let modelPolicy = {
        _denyShow: false,
        _denyEdit:  true,
        _denyDelete: true,
      }
      let userPolicy = {
      }
      return {
        ...modelPolicy,
        ...userPolicy,
      }
    },
  },
};
</script>
